import { useMemo } from 'react';

import { useIsGreaterThan } from '@/hooks/use-is-greather-than.hook';
import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

interface GridColProps {
  scheduleType: ScheduleType;
}

function getCols(type: ScheduleType, isLg: boolean, isSm: boolean): number {
  if (type === ScheduleType.ARRIVAL_ORDER || type === ScheduleType.LABORATORIAL) {
    if (isLg) {
      return 4;
    } else if (isSm) {
      return 3;
    } else {
      return 2;
    }
  }

  return isLg ? 5 : isSm ? 4 : 3;
}

export const useGridCol = ({ scheduleType }: GridColProps): number => {
  const isLg = useIsGreaterThan('lg');
  const isSm = useIsGreaterThan('sm');

  const cols = useMemo(() => getCols(scheduleType, isLg, isSm), [scheduleType, isLg, isSm]);
  return cols;
};
